module.exports = __webpack_public_path__ + "static/assets/f16ba8cca23a44314efcd83489001fde.svg";